module.exports = __webpack_public_path__ + "static/barauna-logo-9f5a6978a2fadc0b13aa6571eb1e207f.png";